"use client";

import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ShareYourReview() {
  const [copied, setCopied] = useState(false);
  const shareUrl = "https://www.industrial-luxury.com/share/review-ref-8823";
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section id="share-your-review" ref={ref} className={cn("py-20 px-6 bg-background border-t border-border/40 transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <div className="space-y-3">
          <h2 className="text-3xl md:text-4xl font-serif text-primary tracking-tight">
            Share Your Review
          </h2>
          <p className="max-w-lg mx-auto text-lg font-light leading-relaxed !text-[hsl(0,0%,0%)]">
            Your perspective matters. Share this unique link to let others know about your experience.
          </p>
        </div>

        {}
        <div className="relative max-w-2xl mx-auto mt-8">
          <div className="flex flex-col sm:flex-row items-stretch border border-border bg-card/20 p-1.5 sm:p-2 gap-3 rounded-sm shadow-sm transition-all duration-300 hover:border-primary/20 hover:shadow-md">
            <div className="flex-1 relative flex items-center bg-background/50 rounded-sm border border-transparent focus-within:border-border/50 transition-colors">
              <Input readOnly value={shareUrl} className="border-input flex min-w-0 rounded-md border py-1 transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-12 w-full border-none bg-transparent shadow-none focus-visible:ring-0 font-mono text-sm px-4 tracking-tight !text-[hsl(221,39%,11%)] file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:aria-invalid:ring-destructive/40 md:text-base" aria-label="Shareable link" />
            </div>
            
            <Button onClick={handleCopy} variant="outline" className="shadow-xs inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border py-2 has-[>svg]:px-3 h-12 px-8 rounded-sm border-border font-medium tracking-wide transition-all duration-300 uppercase text-xs !shadow-[0px_8px_16px_rgba(20,21,31,0.22),_0px_4px_8px_rgba(20,21,31,0.16)] !text-[hsl(0,0%,0%)] !bg-[hsl(210,40%,98%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary hover:text-primary-foreground hover:border-primary active:scale-95 sm:text-sm">
              {copied ? <span className="flex items-center gap-2">
                  <Check className="size-4" />
                  <span>Copied</span>
                </span> : <span className="flex items-center gap-2">
                  <Copy className="size-4" />
                  <span>Copy Link</span>
                </span>}
            </Button>
          </div>
          <p className="mt-3 text-xs text-muted-foreground/60 font-mono uppercase tracking-widest">
            Secure Link • Encrypted
          </p>
        </div>
      </div>
    </section>;
}